import CustomButton from "../../../components/CustomButton";
import Input from "../../../components/form/Input";
import CustomModal from "../../../components/CustomModal";
import {useDispatch, useSelector} from "react-redux";
import {setManageUserModals, tryAddOrUpdateUsers} from "../../../redux/slices/manageUserSlice";
import useInput from "../../../hooks/useInput";
import useDidMount from "../../../hooks/useDidMount";
import {setManageBlogModals, tryAddOrUpdateBlogTags} from "../../../redux/slices/manageBlogSlice";
import {BLOG_TAG_MIN_LENGTH} from "../constants";


export default function BlogTagsFormModal() {


  const {modal, data} = useSelector((state => state.manageBlogs.modals.tagCrud));
  const dispatch = useDispatch();
  const tagName = useInput("");

  const {
    loading: editing
  } = useSelector((state) => state.dynamicElements.editing);

  const isEditForm = !!data;
  const isFormValid = tagName.value.trim().length >= BLOG_TAG_MIN_LENGTH;


  const submitForm = () => {
    dispatch(tryAddOrUpdateBlogTags({
      "title": tagName.value.trim()

    }));
  };

  useDidMount(() => {
    if (!modal) {
      tagName.setValue("");
    } else if (isEditForm) {
      tagName.setValue(data.title);
    }
  }, [modal]);


  return (
    <CustomModal title={isEditForm ? "Update Tag" : "Create a New Tag"}
                 bodyClasses="max-w-screen-sm"
                 showModal={modal}
                 setShowModal={() => dispatch(setManageBlogModals())}
                 loading={editing}
                 button={<CustomButton disabled={editing || !isFormValid}
                                       onClick={submitForm}>{isEditForm ? "Update" : "Create"}</CustomButton>}>
      <div className="flex flex-col p-2 space-y-4">


        <Input label="Tag Name" type="text" color="lightBlue" size="lg"
               placeholder="Name"
               disabled={editing}
               value={tagName.value}
               onChange={tagName.onChange}
               hideError={!tagName.value.trim() || isFormValid}
               errorMessage={`The length of a tag must be ${BLOG_TAG_MIN_LENGTH} characters or more.`}
        />

      </div>
    </CustomModal>
  );
}